module.exports = __webpack_public_path__ + "img/leader-board-header-progress.713f345c.png";